import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import identityStatusMonitor from './stores/plugins/identityStatusMonitor'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from '@/utils/i18n'
import vuetify from '@/plugins/vuetify'
import { useAppStore } from './stores/app'
import 'vuetify/styles'
import '@/assets/styles/main.scss'

// internal icons
import {
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUpload
)

// app icons
import {
  faFileDownload,
  faQuestionCircle,
  faFileUpload,
  faSearch,
  faPlusSquare,
  faPencilAlt,
  faFrownOpen,
  faPrint,
  faSmile,
  faCalendar,
  faCalendarDay,
  faTimes,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faFileDownload,
  faQuestionCircle,
  faFileUpload,
  faSearch,
  faPlusSquare,
  faPencilAlt,
  faFrownOpen,
  faPrint,
  faSmile,
  faCalendar,
  faCalendarDay,
  faTimes,
  faEnvelope,
  faPhone
)

// Create i18n instance

const app = createApp(App)

// Configure Sentry
Sentry.init({
  app,
  dsn: 'https://2cc92036b7684d748495c87eeeecc81b@sentry.io/1724086',
  environment: import.meta.env.VITE_ENV,
})

app.component('vue-fontawesome', FontAwesomeIcon)

const pinia = createPinia()
pinia.use(identityStatusMonitor)
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(vuetify)

app.mount('#app')

// For E2E testing (Cypress or Playwright)
if ((window as any).Cypress || (window as any).__PW_E2E__) {
  ;(window as any).app = app
  ;(window as any).appStore = useAppStore(pinia)
}
